import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone'
import { useTranslation } from "react-i18next";

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  height: '100px',
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


const DropZone = (props) => {
  const { t }  = useTranslation()
  const [files, setFiles] = useState([]);
  const [isAlertMaxFileOpen, openAlertMaxFile] = React.useState(false);
  const onDrop = useCallback(acceptedFiles => {
    // acceptedFiles.forEach((file) => {
    // console.log(file,4444);
    // console.log(acceptedFiles, 5555);
    props.file(acceptedFiles, "onDrop")
    // });
  }, []);
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
  } = useDropzone(
    {
      // accept: 'application/pdf, image/jpg, image/jpeg, image/png',
      multiple: true,
      onDrop
    }
  );
  const handleOnChange = (e) => {
    // console.log(e, 777);
    props.file(e)
  }
  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  return (
    <div className="container">
      <div {...getRootProps({style})}>
        <input {...getInputProps()} onChange={handleOnChange}/>
        <p>{ t("label.dropYourFileHere") } { t("label.or") } <span style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline", cursor: "pointer"}}>{ t("label.chooseFile") }</span></p>
      </div>
    </div>
  );
}

export default DropZone;
